<template>
    <Doughnut
        id="pie-chart"
        :options="chartOptions"
        :data="chartData"
        :key="render"
    />
</template>

<script>
import { Doughnut } from 'vue-chartjs';
import { Chart as ChartJS, ArcElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { throttle } from 'throttle-debounce';

ChartJS.register(Title, ArcElement, Tooltip, Legend, ChartDataLabels);

export default {
    name: 'PieChart',
    components: { Doughnut },
    props: ['dataProps'],
    data() {
        return {
            chartData: {
                trueDataSets: [],
                labels: [],
                datasets: [
                    {
                        data: [],
                        rotation: 0,
                        backgroundColor: [
                            '#699B12',
                            '#82BF00',
                            '#A3D562',
                            '#C4E88B',
                            '#D9F0AB',
                            '#F3F9E6',
                        ],
                        datalabels: {
                            anchor: 'end',
                            align: 'end',
                            offset: 15,
                            padding: 0,
                            formatter: (val, idx) => {
                                if (val <= 1) {
                                    return '';
                                } else {
                                    return `${this.convertGektars(
                                        this.chartData.trueDataSets[idx.dataIndex]
                                    )} \n тыс. га`;
                                }
                            },
                            textAlign: 'center',
                            font: {
                                family: 'Gilroy-semibold',
                                size: 14,
                                color: '#737373',
                            },
                        },
                        tooltips: {
                            enabled: false,
                        },
                        cutout: '60%',
                        spacing: 1,
                    },
                ],
            },
            chartOptions: {
                animation: {
                    duration: 0,
                },
                layout: {
                    padding: {
                        top: 50,
                        left: 100,
                        right: 100,
                    },
                },
                hover: {
                    mode: null,
                },
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio: 0.6,
                plugins: {
                    tooltip: {
                        enabled: true,
                        intersect: false,
                        position: 'nearest',
                        callbacks: {
                            label: (context, idx) => {
                                return `${this.convertGektars(
                                        this.chartData.trueDataSets[context.dataIndex]
                                    )} тыс. га`;
                            },
                        },
                    },
                    legend: {
                        display: false,
                    },
                    tooltips: {
                        display: false,
                    },
                },
            },
            chartPlugins: [ChartDataLabels],
            render: null,
            windowWidth: null,
        };
    },
    watch: {
        dataProps(new_data, old_data) {
            if (old_data === undefined && new_data !== undefined) {
                this.chartData.labels = [
                    ...this.dataProps.map((el) => el.short),
                ];
                this.chartData.datasets[0].data = [
                    ...this.dataProps.map((el) => el.area),
                ];
                var total = this.chartData.datasets[0].data.reduce((a, v) => a + v);
                var inPercent = this.chartData.datasets[0].data.map((v) =>
                    Math.max((v / total) * 100, 1)
                );
                this.chartData.trueDataSets = this.chartData.datasets[0].data;
                this.chartData.datasets[0].data = inPercent;
                this.render++;
            }
        },
        $data: {
            handler: function (newVal, oldVal) {},
            deep: true,
        },
    },
    mounted() {
        this.setWindowWidth();
        window.addEventListener('resize', throttle(1000, this.setWindowWidth));
    },
    computed: {},

    methods: {
        convertGektars(val) {
            return (val * 0.0000001).toFixed(2).replace('.', ',');
        },
        setWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
            if (this.windowWidth <= 560) {
                this.chartOptions.aspectRatio = 1.1;
                this.chartOptions.layout.padding.left = 60;
                this.chartOptions.layout.padding.right = 60;
                this.chartData.datasets[0].datalabels.font.size = 12;
            } else if (this.windowWidth > 560) {
                this.chartOptions.aspectRatio = 0.6;
                this.chartOptions.layout.padding.left = 100;
                this.chartOptions.layout.padding.right = 100;
            }
            this.render++;
        },
    },
};
</script>
